export const getApiUrl = () => process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PREFIX;
